export function secToMillis(sec: number) {
  return sec * 1000;
}

export function millisToSec(millis: number) {
  return millis / 1000;
}
